var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.549183 16H0.657429L5.87986 14.8649C5.98158 14.8479 6.07585 14.8009 6.15043 14.7297L14.9987 5.89194C15.6451 5.24774 16.0057 4.37151 15.9999 3.45955C16.0011 2.54049 15.6417 1.6576 14.9987 1.00009C14.3538 0.354489 13.4765 -0.00571525 12.5634 0.000130364C11.6445 -0.00799142 10.7631 0.363697 10.1281 1.02715L1.30681 9.8649C1.22902 9.92744 1.1723 10.0123 1.14444 10.1081L0.00799863 15.3243C-0.0230253 15.5116 0.0372616 15.7024 0.170369 15.8379C0.270278 15.9397 0.406441 15.998 0.549183 16ZM12.5634 1.08121C13.8636 1.0811 14.9176 2.13378 14.9177 3.43239C14.9177 3.44144 14.9177 3.45049 14.9176 3.45955C14.9264 4.0782 14.6821 4.67368 14.2411 5.10817L10.9128 1.75682C11.3513 1.3216 11.9452 1.07847 12.5634 1.08121ZM10.1552 2.54065L13.4834 5.86494L5.77156 13.5405L2.4433 10.2433L10.1552 2.54065ZM2.01036 11.3244L4.68919 14L1.25269 14.7568L2.01036 11.3244Z",
    fill: "#219EBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.98cf6ae10e83e5605a5734c45ebdc818.svg";
export { ForwardRef as ReactComponent };